import { render } from "./TreatmentListPage.vue?vue&type=template&id=c9ae0480&scoped=true"
import script from "./TreatmentListPage.vue?vue&type=script&lang=js"
export * from "./TreatmentListPage.vue?vue&type=script&lang=js"

import "./TreatmentListPage.vue?vue&type=style&index=0&id=c9ae0480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ae0480"]])

export default __exports__